module.exports = __webpack_public_path__ + "img/GenericSlotMixAlt_2208x1242_5.c671ee70.png";